var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('user-list',{attrs:{"listItems":_vm.listItems,"clonedItems":_vm.clonedItems,"_fn_changeCurrentEmployee":_vm.changeCurrentEmployee}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }